export const container = ({ theme: { colors } }) => ({
    background: colors.bgGrey,
    display: 'block',
    marginLeft: '-1.5rem',
    marginRight: '-1.5rem',
});
